import ComponentManager from '../shared/component-manager';
import OtherOccupationField from '../shared/components/other-occupation-field';

import TeacherURLSharings from './components/teacher/teacher-url-sharings';

class TeacherComponentManager extends ComponentManager {
  initializeComponents() {
    OtherOccupationField.initialize('.teacher-occupation-select');
    TeacherURLSharings.initialize('.teacherURLSharings');
  }
}

export const initialize = () => {
  jQuery(() => {
    new TeacherComponentManager([OtherOccupationField, TeacherURLSharings]);
  });
};
